import merge from 'lodash/merge'
import ApplicationInit from './app/init.js'
import { show as showOverlay, hide as hideOverlay } from './utils/overlay'
import Panel from './panel';
import openPopup from './modules/popup';
import './modules/jquery.setHtmlByUrl.js';
import './modules/bootstrapMaterialDesign';
import PageAnimate from './modules/page-animate';

window.RS = window.RS || {};
merge(window.RS, {
	Init: ApplicationInit,
	Utils: {
		popup: openPopup,
		overlay: {
			show: showOverlay,
			hide: hideOverlay
		},
		PageAnimate: PageAnimate,
	},
});

$(document).ready(function () {
	const panel = new Panel;

	merge(window.RS, {
		Panel: panel
	});
});
